import { fontText, hexToRgbA, isMobileApp, StylesIndexInjections } from 'common-react';
import { fieldBoxShadow, focusStyle } from '../styles/mixins';
import { createStyles, makeUiStyles, Theme } from '../styles/styles';

const mobileBottomPadding = 16;
const getMobileBottomPadding = (theme: Theme) => mobileBottomPadding + theme.space.mobileBottomPadding();

export default makeUiStyles((theme: Theme) => createStyles({
  secondaryButton: {
    whiteSpace: 'nowrap',
  },
  collapseButton: {
    whiteSpace: 'nowrap',
  },
  triggerIcon: {
    width: 24,
    height: 24,
    transition: 'transform 0.18s ease-out',
    marginLeft: 4,
    color: 'currentColor',
    '& path': {
      fill: 'currentColor',
    },
  },
  triggerIconOpen: {
    transform: 'rotate(180deg)',
  },
  popover: {
    border: `1px solid ${theme.color.greys[15]}`,
    marginTop: 8,
    borderRadius: 16,
    backgroundColor: theme.color.greys[0],
    boxShadow: fieldBoxShadow(theme).bs3,
  },
  menuList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 10,
    padding: '12px 8px 8px 8px',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      gap: 0,
      width: '100%',
    },
  },
  menuItem: {
    padding: 0,
    minHeight: 'unset',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-focusVisible': {
      ...focusStyle(theme, -2),
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      width: '100%',
      borderTop: `1px solid ${theme.color.greys[15]}`,
      '&:first-child': {
        borderTop: 0,
      },
    },
  },
  menuItemContent: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: 10,
    padding: 8,
    borderRadius: 8,
    color: theme.color.greys[80],
    '&:hover': {
      backgroundColor: hexToRgbA(theme.color.greys[80], 0.08),
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      padding: '12px 0',
    }
  },
  menuItemText: {
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.color.greys[80],
    font: fontText('normal', theme.fontSize.base, 24),
  },
  menuItemSpinner: {
    width: 'auto',
    position: 'relative',
    right: -26,
    marginLeft: -26,
  },
  menuItemIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  dialog: {
    '& .MuiPaper-root': {
      marginBottom: 0,
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,

      '& > div': {
        [theme.breakpoints.down('sm')]: {
          margin: 0,
          padding: 16,
          paddingBottom: isMobileApp() ? getMobileBottomPadding(theme) : mobileBottomPadding,
        },
      }
    },
    '& .MuiDialogContent-root > div': {
      [theme.breakpoints.down('sm')]: {
        padding: 0,
      },
    },
  },
  dialogCard: {
    paddingTop: 40,
    paddingBottom: 40,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  menuDivider: {
    font: fontText('normal', theme.fontSize.s, 20),
    marginTop: 8,
    padding: '12px 0',
    '&.Mui-disabled': {
      color: theme.color.greys[60],

    },
  },
}), { name: 'ActionMenu', index: StylesIndexInjections.OTHER });
